
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prihlasenie",
      function () {
        return require("private-next-pages/prihlasenie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prihlasenie"])
      });
    }
  